export default __webpack_public_path__ + "static/media/thumbnail2.ffe6c077.jpg";